import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  rooms: {},
  isLoading: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
